export { default as Navbar } from './Navbar'
export { default as NavbarE } from './NavbarE'
export { default as NavbarM } from './NavbarM'
export { default as NavbarS } from './NavbarS'
export { default as NavbarR } from './NavbarR'
export { default as NavbarDemo } from './NavbarDemo'
export { default as NavbarCharge } from './NavbarCharge'
export { default as NavbarEv } from './NavbarEv'

export { default as Tenantbar } from './Tenantbar'

export { default as AppMain } from './AppMain'
export { default as AppMainT } from './AppMainT'
export { default as AppMainM } from './AppMainM'
export { default as AppMainE } from './AppMainE'
export { default as AppMainS } from './AppMainS'
export { default as AppMainR } from './AppMainR'
export { default as AppMainEv } from './AppMainEv'
// export { default as Ainfo } from './Ainfo'

export { default as Binfo } from './Binfo'
export { default as BinfoS } from './BinfoS'

export { default as Cinfo } from './Cinfo'
export { default as Myinfo } from './Myinfo'

export { default as Personal } from './Personal'
export { default as PersonalT } from './PersonalT'

// 临时英文版本
export { default as langEn } from './langEn'
export { default as langHeaderEn } from './langHeaderEn'
export { default as BinfoEn } from './BinfoEn'
export { default as PersonalEn } from './PersonalEn'



// WEBPACK FOOTER //
// ./src/views/layout/components/index.js